/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationCompany } from './';
import {
    OrganizationCompanyFromJSON,
    OrganizationCompanyFromJSONTyped,
    OrganizationCompanyToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationAndCompanies
 */
export interface OrganizationAndCompanies {
    /**
     * 
     * @type {Array<OrganizationCompany>}
     * @memberof OrganizationAndCompanies
     */
    companies: Array<OrganizationCompany>;
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof OrganizationAndCompanies
     */
    id: string;
    /**
     * The name of the organization.
     * @type {string}
     * @memberof OrganizationAndCompanies
     */
    name: string;
    /**
     * The ID of the transitional company id if present
     * @type {string}
     * @memberof OrganizationAndCompanies
     */
    transitionalCompanyId?: string;
}

/**
 * Check if a given object implements the OrganizationAndCompanies interface.
 */
export function instanceOfOrganizationAndCompanies(value: object): value is OrganizationAndCompanies {
    if (!('companies' in value) || value['companies'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OrganizationAndCompaniesFromJSON(json: any): OrganizationAndCompanies {
    return OrganizationAndCompaniesFromJSONTyped(json, false);
}

export function OrganizationAndCompaniesFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAndCompanies {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': ((json['companies'] as Array<any>).map(OrganizationCompanyFromJSON)),
        'id': json['id'],
        'name': json['name'],
        'transitionalCompanyId': json['transitionalCompanyId'] == null ? undefined : json['transitionalCompanyId'],
    };
}

export function OrganizationAndCompaniesToJSON(value?: OrganizationAndCompanies | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companies': ((value['companies'] as Array<any>).map((v) => OrganizationCompanyToJSON(v))),
        'id': value['id'],
        'name': value['name'],
        'transitionalCompanyId': value['transitionalCompanyId'],
    };
}

